import React from 'react';
import { Box } from '@material-ui/core';
import FsEventsFeedIconLoader from 'ui-elements/image-loaders/FsEventsFeedIconLoader';
import {
  ContainerBox,
  Description,
  IconWrapperBox,
  Name,
} from './SingleEventsFeedItem.style-elements';

export interface SingleEventsFeedItemDataProps {
  id: number;
  eventType: string;
  title: string;
  additionalInformation: string;
  amount: string;
  date: string;
  tags: string;
}

const SingleEventsFeedItem: React.FC<SingleEventsFeedItemDataProps> = ({
  eventType,
  title,
  additionalInformation,
  amount,
  date,
  tags,
}) => {
  return (
    <ContainerBox>
      <IconWrapperBox>
        <FsEventsFeedIconLoader type={eventType} />
      </IconWrapperBox>
      <Box>
        <Name>
          Title: <span>{title}</span>
        </Name>
        <Description>
          Amount: <span>{amount}</span>
        </Description>
        {tags.length && <Description>Tags: {tags}</Description>}
        <Description>
          {eventType} on {date}
        </Description>
        <Description>{additionalInformation}</Description>
      </Box>
    </ContainerBox>
  );
};

export default SingleEventsFeedItem;
